(function ($) {
	"use strict";

	var nmbSelection = false;
	var employeeSelection = false;
	var maxValue = 0;

	var cookie = Cookies.get("selected_employee");

	$(".employee-dropdown .sub-menu li a").click(function () {
		var selectedWorker = $(this).html();
		var mainMenu = $(".collapse");
		mainMenu.html(selectedWorker);
		if (selectedWorker !== "Medewerkers") {
			employeeSelection = true;
		}
	});

	$(".employee-dropdown .sub-menu li a").on("click", function () {
		var employeeId = $(this).data("employee-id");
		$("[data-employee]").val(employeeId);
	});

	$(".return-btn").click(function() {
		var toolId = $(this).data("tool-id");
		$("[data-tool]").val(toolId);
	});

	$(".custom-select").change(function () {
		var value = $(this).val();
		if (value === "Aantal...")
		{
			nmbSelection = false;
		}
		if (value > 0)
		{
			nmbSelection = true;
		}

			});

	$(function () {
		$(".submit-btn").click(function () {
			if (nmbSelection === false && employeeSelection === false) {
				alert("Selecteer een aantal en een medewerker");
			} else if (nmbSelection === false) {
				alert("Selecteer een aantal");
			} else if (employeeSelection === false) {
				alert("Selecteer een medewerker");
			}

		});



		});

	$(".employee-list > li").click(function () {
		var selected = $(this);
		if (selected.children(".top").length === 0) {
			activateButtons();

			var selectedEmployeeId = $(this).data("employeeid");
			var selectEmployeeElt = $(".employee-dropdown > select#EmployeeId");
			selectEmployeeElt.val(selectedEmployeeId);
			var selectedEmployeeNumber = $(this).find("span.amount").data("employeenumber");
			$(".number-button").val(selectedEmployeeNumber);
		}
	});

	$(".employee-dropdown > select#EmployeeId").change(function () {
		activateButtons();
		var employeeId = $(this).val();
		var targetHelper = ".employee-list > li#employee-" + employeeId + "> .employee-content > .amount";
		var employeeLi = $(targetHelper);
		var toolNumber = employeeLi.data("employeenumber");
		$(".number-button").val(toolNumber);
	});

	$(".add").click(function () {
		var currentValue = parseInt($(".number-button").val());
		var newValue = currentValue + 1;
		var remaingingTools = parseInt($("#remainingtools").val());
		if (maxValue === 0) {
			maxValue = remaingingTools + currentValue;
		}
		if (currentValue < maxValue) {
			$(".number-button").val(newValue);
		}
	});
	$(".substract").click(function () {
		var currentValue = parseInt($(".number-button").val());
		var newValue = currentValue - 1;

		if (currentValue !== 0) {
			$(".number-button").val(newValue);
		}
	});

	$("form button.save").attr('disabled', 'disabled');

	function activateButtons() {
		$("form div").show();
		$("form button.save").removeAttr('disabled');
		$(".save").css("background-color", "#FC4137");
	}

		$(".alert").css({
		position: "fixed",
		width: "274px",
		top: "50%"
	});

	$(".alert>button.close").on("click", function () {
		$(".alert").slideUp(function () {
			$(this).remove();
		});
	});


	if (typeof (cookie) !== "undefined" && cookie !== null)
	{
		$("#EmployeeId").val(cookie);
		var targetHelper = ".employee-list > li#employee-" + cookie + "> .employee-content > .amount";
		var employeeLi = $(targetHelper);
		var toolNumber = employeeLi.data("employeenumber");
		$(".number-button").val(toolNumber);
		activateButtons();
	}
})(jQuery);
